export default {
    daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    limit: "Limit reached ({{limit}} max).",
    loading: "Loading...",
    minLength: "Min. length",
    months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ],
    notSelected: "None selected",
    required: "Required",
    search: "Search",
    dateFormat: 'dd/MM/yyyy'
}